/**
 * Tollwerk namespace
 *
 * @type {Object}
 */
var Tollwerk = window.Tollwerk || {};
